import { IPortfolioBalancingDto } from "../../interfaces/portfolio-balancing/IPortfolioBalancingDto";
import { ISimplePortfolioBalancingDto } from "../../interfaces/portfolio-balancing/ISimplePortfolioBalancingDto";
import { cryptoPortfolioService } from "../httpService/cryptoPorfolio.service";

export async function tryGetPortfolioBalancingByWalletId(walletId: string) {
    return await cryptoPortfolioService.get<IPortfolioBalancingDto[]>(`/portfoliobalancing/getbywalletid/${walletId}`);
}

export async function tryUpdateDesiredPercentageList(simplePortfolioBalancingList: ISimplePortfolioBalancingDto[]) {
    return await cryptoPortfolioService.put('/portfoliobalancing/updatedesiredpercentage', simplePortfolioBalancingList);
}